const SubOrderProductValidation = (selectedInputRows, selectedOutputRows) => {
  let errors = {};

  // Validate input items
  if (selectedInputRows.length === 0) {
    errors._inputItems = "Please select at least one input item";
  } else {
    for (let x = 0; x < selectedInputRows.length; x++) {
      const row = selectedInputRows[x];
      if (row.importCategoryId != null) continue; // categories skip qty validation
      if (row.qty === 0 || row.qty === "") {
        errors._inputItems = "Input item quantities cannot be empty or zero";
        break;
      } else if (row.itemUintsPerOrderUnit === 0 || row.itemUintsPerOrderUnit === "") {
        errors._inputItems = "Please update item units per order unit for input items";
        break;
      } else if (row.qty < 0 || row.itemUintsPerOrderUnit < 0) {
        errors._inputItems = "Input item quantities and units must be positive numbers";
        break;
      }
    }
  }

  // Validate output items
  if (selectedOutputRows.length === 0) {
    errors._outputItems = "Please select at least one output item";
  } else {
    for (let x = 0; x < selectedOutputRows.length; x++) {
      const row = selectedOutputRows[x];
      if (row.importCategoryId != null) continue; // categories skip qty validation
      if (row.qty === 0 || row.qty === "") {
        errors._outputItems = "Output item quantities cannot be empty or zero";
        break;
      } else if (row.itemUintsPerOrderUnit === 0 || row.itemUintsPerOrderUnit === "") {
        errors._outputItems = "Please update item units per order unit for output items";
        break;
      } else if (row.qty < 0 || row.itemUintsPerOrderUnit < 0) {
        errors._outputItems = "Output item quantities and units must be positive numbers";
        break;
      }
    }
  }

  // Validate that input and output import items are not the same (exclude categories)
  const inputItemIds = selectedInputRows.filter((r) => r.importId != null).map((r) => r.importId);
  const outputItemIds = selectedOutputRows.filter((r) => r.importId != null).map((r) => r.importId);
  const duplicateItems = inputItemIds.filter((id) => outputItemIds.includes(id));

  if (duplicateItems.length > 0) {
    errors._duplicateItems = "Same item cannot be both input and output";
  }
  return errors;
};

export default SubOrderProductValidation;
